import React from 'react';

import { ImageComponent } from './Styled';

interface ImgProps {
  src: string;
  width: string;
  height: string;
}

const Image: React.FC<ImgProps> = ({ src, width, height }) => (
  <ImageComponent src={src} width={width} height={height} />
);

Image.defaultProps = {
  src: '',
};

export default Image;
export { Image };
